import { ErrorMessage } from 'formik';
import React, { useState } from 'react'
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import { getInputHeight } from 'src/utils/formUtils/getInputHeight';
import { twMerge } from 'tailwind-merge';

type Props = {
    name: string;
    extraClasses?: string;
    label?: string;
    inputProps?: {
        extraClasses?: string;
    },
    iconProps?: {
        extraClasses?: string;
    };
    size?: 'small' | 'medium' | 'large';

} & Omit<React.ComponentProps<'input'> , "size">

const ATMPassword = ({
    name,
    extraClasses = '',
    label,
    inputProps,
    iconProps,
    size='small',
    onFocus,
    onBlur,
    className,
    ...rest
}: Props) => {

    const [isShowPassword, setIsShowPassword] = useState(false);
    const [isFocussed, setIsFocussed] = useState(false);

    return (
        <div className='relative w-full'>
            {
                label ?
                    <label className='text-slate-700 block mb-1' > {label}  {rest.required && <span className='text-red-400' > * </span>} </label>
                    :
                    null
            }

            <div className={twMerge(`flex w-full items-center overflow-hidden rounded border border-slate-400 bg-white ${getInputHeight(size)} ${extraClasses} ${isFocussed ? 'border-2 border-primary-main' : ''}`)} >
                <input
                    {...rest}
                    name={name}
                    type={isShowPassword ? 'text' : 'password'}
                    className={twMerge(`h-full min-w-0 flex-1 border-none bg-transparent px-2 py-0 text-slate-700 outline-none ring-0 focus:outline-none focus:ring-0 [&::-ms-clear]:hidden [&::-ms-reveal]:hidden ${inputProps?.extraClasses} ${className || ''}`)}
                    onFocus={(event) => {
                        setIsFocussed(true);
                        onFocus?.(event);
                    }}
                    onBlur={(event) => {
                        setIsFocussed(false);
                        onBlur?.(event);
                    }}
                />

                <button
                    type="button"
                    tabIndex={-1}
                    aria-label={isShowPassword ? 'Hide password' : 'Show password'}
                    onClick={() => setIsShowPassword(prev => !prev)}
                    className={twMerge(`flex h-full shrink-0 items-center bg-transparent px-2 text-xl text-slate-500 ${iconProps?.extraClasses}`)}
                >
                    {
                        isShowPassword ?
                            <AiFillEyeInvisible />
                            :
                            <AiFillEye />
                    }
                </button>
            </div >

            {
                name &&
                <ErrorMessage name={name} >
                    {
                        (errMsg) => (
                            <p className="font-poppins absolute text-[14px] text-start mt-0 text-red-500"> {errMsg} </p>
                        )
                    }
                </ErrorMessage>
            }


        </div>
    )
}

export default ATMPassword
